import { useIntl } from 'react-intl';

import { useQueryClient } from '@tanstack/react-query';

import { useProductOverlaidList } from 'common/queries/product-module';

import { useMutation } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';

import * as productServices from 'services/product';
import { downloadBulkProductOverlay } from 'services/overlay';

import * as api from 'config/axios';

import Messages from 'i18n/messages/product';
import {
  useGetProductOriginFullViewForProductOverlay,
  useProductFullView,
} from 'hooks';
import { useReloadDocumentCertificateTab } from 'hooks/useReloadDocumentCertificateTab';
import { useGetProductItemModules } from 'pages/product-full-view/components/product-new-detail-view/queries';

export const EXPORT_PRODUCT_PROPERTIES = ['product', 'export-property'];
export const EXPORT_PRODUCT_OVERLAY_PROPERTIES = [
  'product',
  'export-product-overlay-property',
];

export const useExportProductProperty = () => {
  const intl = useIntl();

  return useMutation({
    mutationKey: EXPORT_PRODUCT_PROPERTIES,
    mutationFn: async (params) => {
      const response = await productServices.exportProductProperties(params);

      const { isSuccess, data } = response || {};

      if (isSuccess) {
        return Promise.resolve(data || {});
      } else {
        return Promise.reject(response || 'Sever Error');
      }
    },
    onSuccess: (data) => {
      api.sendDownload({ url: data?.url });
      CustomNotification.success('Download successfully');
    },
    onError: (response) => {
      const errorMessage =
        response?.message ||
        response?.data?.message ||
        intl.formatMessage(Messages.exportProductPropertiesError);

      CustomNotification.error(errorMessage);
    },
  });
};

export const useExportSearchProductProperty = () => {
  const intl = useIntl();

  return useMutation({
    mutationFn: async (params) => {
      const response = await productServices.exportSearchProductProperties(
        params
      );

      const { isSuccess } = response || {};

      if (isSuccess) {
        return Promise.resolve(response || {});
      } else {
        return Promise.reject(response || 'Sever Error');
      }
    },
    onSuccess: (response) => {
      if (response?.message) {
        CustomNotification.success(response?.message);
      } else {
        api.sendDownload({ url: response?.data?.url });
        CustomNotification.success('Download successfully');
      }
    },
    onError: (response) => {
      const errorMessage =
        response?.message ||
        response?.data?.message ||
        intl.formatMessage(Messages.exportProductPropertiesError);

      CustomNotification.error(errorMessage);
    },
  });
};

export const useExportProductOverlayProperty = () => {
  const intl = useIntl();

  return useMutation({
    mutationKey: EXPORT_PRODUCT_OVERLAY_PROPERTIES,
    mutationFn: async (params) => {
      const response = await downloadBulkProductOverlay(params);

      const { isSuccess, data } = response || {};

      if (isSuccess) {
        return Promise.resolve(data || {});
      } else {
        return Promise.reject(response || 'Sever Error');
      }
    },
    onSuccess: (data) => {
      api.sendDownload({ url: data?.url });
      CustomNotification.success('Download successfully');
    },
    onError: (response) => {
      const errorMessage =
        response?.message ||
        response?.data?.message ||
        intl.formatMessage(Messages.exportProductPropertiesError);

      CustomNotification.error(errorMessage);
    },
  });
};

export const useGetLatestProductFullViewInBulkEdit = ({ productId }) => {
  const queryClient = useQueryClient();

  const { invalidateAllProductFull } = useProductFullView({
    productId,
  });

  const { refetchDataProductModules } = useGetProductItemModules(productId, {
    enabled: false,
  });

  const { invalidAllProductOriginFull } =
    useGetProductOriginFullViewForProductOverlay({
      enabled: false,
    });

  const { reloadDocumentCertificateTab } = useReloadDocumentCertificateTab();

  const { invalidateProductOverlaidList } = useProductOverlaidList(null, {
    enabled: false,
  });

  const getLatestFullViewData = () => {
    queryClient.invalidateQueries({ queryKey: ['pim'] });
    invalidateAllProductFull();
    invalidAllProductOriginFull();
    reloadDocumentCertificateTab();
    refetchDataProductModules();
  };

  const getLatestFullViewDataOverlay = () => {
    getLatestFullViewData();
    invalidateProductOverlaidList();
  };

  return {
    getLatestFullViewData,
    getLatestFullViewDataOverlay,
  };
};
